import moment from "moment-timezone";

// Always use the event timezone, regardless of other forms' Moment defaults.
export const formatScheduleAppointments = (appointments, timeZone) =>
  appointments.map((appointment) => ({
    ...appointment,
    start: moment(appointment.start).tz(timeZone).format("hh:mm A"),
    end: moment(appointment.end).tz(timeZone).format("hh:mm A"),
  }));
